import { action, observable } from 'mobx';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import cmsApi from '@src/services/cms-api';
import MatchBracketStore from './components/event-overview/match-bracket/store';

const MAIN_TAB_IDS = [0, 1, 2, 3];
const CMS_API = 'https://jxsj.xoyo.com/api.php';
const CMS_CATEGORY_ID = 7877;
const CMS_ARTICLE_ID = 1;

const normalizeString = value => (typeof value === 'string' ? value.trim() : '');
const normalizeHtml = value => (typeof value === 'string' ? value : '');
const normalizeUrl = value => {
  const url = normalizeString(value);
  return url.indexOf('//') === 0 ? `https:${url}` : url;
};
const normalizeLiveItems = value => {
  const liveConfig = normalizeString(value);

  if (!liveConfig) {
    return [];
  }

  try {
    const liveConfigMap = JSON.parse(liveConfig);

    if (!liveConfigMap || typeof liveConfigMap !== 'object' || Array.isArray(liveConfigMap)) {
      return [];
    }

    return Object.keys(liveConfigMap)
      .sort((firstIndex, secondIndex) => Number(firstIndex) - Number(secondIndex))
      .map(itemKey => liveConfigMap[itemKey])
      .map(item => ({
        imageUrl: normalizeUrl(item && item.url),
        videoUrl: normalizeUrl(item && item.alt)
      }))
      .filter(item => item.imageUrl && item.videoUrl);
  } catch (error) {
    return [];
  }
};

const normalizeActivityContent = response => {
  const article = Array.isArray(response) ? response[0] : response;

  if (!article || typeof article !== 'object') {
    throw new Error('活动内容为空');
  }

  return {
    sloganUrl: normalizeUrl(article.slogan),
    scheduleImageUrl: normalizeUrl(article.home_schedule),
    matchConfigUrl: normalizeUrl(article.schedule_json),
    liveItems: normalizeLiveItems(article.home_live),
    guildDescriptionHtml: normalizeHtml(article.second_desc),
    guildRulesHtml: normalizeHtml(article.second_rule),
    competitionDescriptionHtml: normalizeHtml(article.third_desc),
    activityRulesHtml: normalizeHtml(article.third_rule),
    gameRulesHtml: normalizeHtml(article.third_gameRule),
    rewardDescriptionHtml: normalizeHtml(article.four_desc),
    swordRewardHtml: normalizeHtml(article.four_prize_js),
    greenRewardHtml: normalizeHtml(article.four_prize_ls),
    swordChampionExclusiveHtml: normalizeHtml(article.four_prize_js_gjzs),
    swordRareMountHtml: normalizeHtml(article.four_prize_js_xyzq),
    swordCustomPartnerHtml: normalizeHtml(article.four_prize_js_dzhb),
    greenChampionExclusiveHtml: normalizeHtml(article.four_prize_ls_gjzs),
    greenRareMountHtml: normalizeHtml(article.four_prize_ls_xyzq),
    greenExtraRewardHtml: normalizeHtml(article.four_prize_ls_fhjl)
  };
};

class MainStore extends BaseStore {
  @observable activeTab = 0;
  @observable.ref activityContent = null;
  @observable activityContentStatus = 'loading';
  @observable.ref activityContentError = null;

  matchBracketStore = new MatchBracketStore();

  use() {
    super.use();

    useEffect(() => {
      this.loadActivityContent();
    }, []);
  }

  @action.bound
  async loadActivityContent() {
    this.activityContentStatus = 'loading';
    this.activityContentError = null;

    try {
      const response = await cmsApi.getArticleDetail({
        categoryId: CMS_CATEGORY_ID,
        articleId: CMS_ARTICLE_ID,
        api: CMS_API
      });
      this.activityContent = normalizeActivityContent(response);
      this.activityContentStatus = 'success';
    } catch (error) {
      this.activityContent = null;
      this.activityContentError = error;
      this.activityContentStatus = 'error';
    }
  }

  @action.bound
  setActiveTab(tabId) {
    if (!MAIN_TAB_IDS.includes(tabId) || this.activeTab === tabId) {
      return;
    }

    this.activeTab = tabId;
  }
}

export default MainStore;
